export default {
  homePage:{
    home:'Home',
    factory:'Factory',
    supplier:'Supplier',
    login:'Login',
    logout:'Logout',
    signUp:'Sign up',
  },
  
}
